export function DealerNamePlaceholder() {
  return (
    <span className="inline-block h-4 w-28 animate-pulse rounded bg-mp-border align-middle">
      <span className="sr-only">Loading dealer name</span>
    </span>
  );
}
